import {
    FETCH_LOGIN_REQUEST,
    FETCH_LOGIN_SUCCESS,
    INTIALIZE_TOKEN,
    REMOVE_TOKEN,
    INTIALIZE_LANG,
    INTIALIZE_TYPE,
    FETCH_LOGIN_FAILED
} from "./type";

import axios from "axios";
import { API_ENDPOINT } from '../../AppConfig';
import { hideLoading, showLoading } from 'react-redux-loading-bar';
import { showSnack } from 'react-redux-snackbar';

export function LoginRequest(data, lang) {
    return (dispatch, getState) => {
        dispatch({ type: FETCH_LOGIN_REQUEST });
        dispatch(showLoading());
        let uri = `${API_ENDPOINT}/signin`;
        axios.post(uri, data, {
            headers: {
                'Accept-Language': lang
            }
        }).then(response => {
            saveToLocalStorage('JAZANtoken', JSON.stringify(response.data.token));
            saveToLocalStorage('JAZANuser', JSON.stringify(response.data.user));
            saveToLocalStorage('JAZAusername', JSON.stringify(response.data.user.name));
            saveToLocalStorage('JAZAuserphone', JSON.stringify(response.data.user.phone));

            dispatch({ type: FETCH_LOGIN_SUCCESS, payload: response.data });
            dispatch(hideLoading());
        }).catch(error => {
            dispatch({ type: FETCH_LOGIN_FAILED });
            if (!error.response) {
                dispatch(hideLoading());
                dispatch(showSnack('myUniqueId', {
                    label: lang === 'en' ? 'Network Error' : 'خطأ فى الاتصال بالانترنت',
                    timeout: 7000,
                    button: { label: lang === 'en' ? 'LogIn' : ' تسجيل الدخول' }
                }));
            } else if (error.response.status === 404 || error.response.status === 422) {
                dispatch(hideLoading());
                dispatch(showSnack('myUniqueId', {
                    label: lang === 'en' ? 'Password or email is not correct' : 'البريد الالكترونى او كلمة المرور غير صحيحة',
                    timeout: 7000,
                    button: { label: lang === 'en' ? 'LogIn' : ' تسجيل الدخول' }
                }));
            } else if (error.response.status === 401) {
                dispatch(hideLoading());
            }
            else if (error.response.status === 403) {
                dispatch(hideLoading());
                dispatch(showSnack('myUniqueId', {
                    label: error.response.data.errors,
                    timeout: 7000,
                    button: { label: lang === 'en' ? 'LogIn' : ' تسجيل الدخول' }
                }));
            }
        })
    }
}

export function IntializeToken(token, lang, user) {
    return (dispatch, getState) => {
        dispatch({ type: INTIALIZE_TOKEN, Payload: { token: token, user: user, lang: lang }, });
    }
}
export function saveToLocalStorage(key, value) {
    localStorage.setItem(key, value);
}
export function changeType(type) {
    saveToLocalStorage('JazanType', type);
    return (dispatch, getState) => {
        dispatch({ type: INTIALIZE_TYPE, Payload: type });
    }
}
export function changeLang(lang) {
    saveToLocalStorage('JazanLanguage', JSON.stringify(lang));
    return (dispatch, getState) => {
        dispatch({ type: INTIALIZE_LANG, lang: lang });
    }
}
export function sendLogout() {
    saveToLocalStorage('JAZANtoken', '');
    saveToLocalStorage('JAZANuser', '');
    return (dispatch, getState) => {
        dispatch({ type: REMOVE_TOKEN });
    }
}